const state = {
  tagList: []
}

const mutations = {
  ADD_ROUTE_NAME: (state, val) => {
    if (state.tagList.some(item => item === val)) {
      return
    } else {
      state.tagList.push(val)
    }
  },
  CLEAR_ROUTE_LIST: (state, val) => {
    state.tagList = val
  },
  ADD_ROUTE_URL: (state, val) => {
    state.cacheUrl.push(val)
  },
  DELET_ROUTE: (state, val) => {
    state.tagList.forEach((item, index) => {
      if (item === val) {
        state.tagList.splice(index, 1)
      }
    })
  }
}

const actions = {
  addRouteName({ commit }, route) {
    commit('ADD_ROUTE_NAME', route.name)
  },
  clearRouteList({ commit }, val) {
    commit('CLEAR_ROUTE_LIST', val)
  },
  deleteRoute({ commit }, val) {
    commit('DELET_ROUTE', val)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
